import { render } from "./app-layout.vue?vue&type=template&id=4e05fc88"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/layout/app-layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e05fc88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e05fc88', __exports__)) {
    console.log('reload')
    api.reload('4e05fc88', __exports__)
  }
  
  module.hot.accept("./app-layout.vue?vue&type=template&id=4e05fc88", () => {
    console.log('re-render')
    api.rerender('4e05fc88', render)
  })

}


export default __exports__